module.exports = __webpack_public_path__ + "img/barva-zakladni_81_reflexni-zluta.86d6862e.png";